export function getButtonClass(disabled: boolean, inCart: boolean): string {
  if (disabled && !inCart) {
    return 'text-gray-700 border-gray-200 bg-gray-200 cursor-default / opacity-50'
  }
  if (inCart) {
    return 'border-primary-light-bg text-primary-bright bg-primary-light-bg / hover:border-primary-bright hover:text-primary-mid / c-compare-btn--added'
  }
  return 'text-gray-700 border-gray-150 bg-gray-150 / hover:border-primary-bright-light hover:bg-primary-light-bg hover:text-primary-bright'
}

export function getIconOpacity(
  disabled: boolean,
  inCart: boolean,
  opacity: string,
): string {
  if (disabled) {
    return 'opacity-60'
  }
  return inCart ? 'opacity-100' : opacity
}

export function getIconSrc(
  disabled: boolean,
  inCart: boolean,
  checkmarkIcon: string,
  addIcon: string,
): string {
  if (disabled && !inCart) {
    return '/static/icons/icon-plus-black.svg'
  }

  if (inCart) {
    return `/static/icons/${checkmarkIcon}.svg`
  }

  return `/static/icons/${addIcon}.svg`
}
